let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c52tG")).then(() => parcelRequire('5lbHB'));